import axios from 'axios';
import React, { useEffect, useState } from 'react';
import CustomPagination from '../../components/Pagination/CustomPagination';
import SingelContent from '../../components/SingleContent/SingelContent';
import './Trending.css'
const Tranding = () => {
    const [content, setContent] = useState([]);
    const [page, setPage] = useState(1)
    const fatchTrending = async () => {
        const { data } = await axios.get(
            `https://api.themoviedb.org/3/trending/all/day?api_key=16d05b1ea65094d893b14e9c9241bf31&page=${page}`
        );
        console.log(data)
        setContent(data.results)
    }
    useEffect(() => {
        fatchTrending()
    }, [page]);
    return (
        <div className="hiren" style={{marginTop:45}}>
            <span className="pageTitle">Trending</span>
            <div className="trending">
                {
                    content && content.map((c) => ( <SingelContent key={c.id}
                    id={c.id}
                    poster={c.poster_path}
                    title={c.title || c.name}
                    date={c.first_air_date || c.release_date}
                    media_type={c.media_type}
                    vote_average={c.vote_average}/>))
                }
            </div>
            <CustomPagination setPage={setPage} />
        </div>
    )
}
export default Tranding
